import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/scroll-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/site-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/context/active-section-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"Instrument_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"],\"variable\":\"--font-heading\",\"display\":\"swap\"}],\"variableName\":\"headingFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-body\",\"display\":\"swap\"}],\"variableName\":\"bodyFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/aioScanner.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/colorNoteImg.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/liveSpeakerImg.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/logo.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/metacam-og.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/taskManagementImg.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/tiziImg.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/vtvImg.webp");
